import { MAIN_THEME } from '@styles';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

interface ILeftSideStaticColumn {
  title: string;
  fields: {
    title: string;
    value: string;
    type: 'text' | 'date';
  }[];
}

const useStyles = makeStyles()(() => ({
  leftSideTitle: {
    fontSize: MAIN_THEME.fontSize.lg,
    margin: '20px 0 30px',
    padding: '0 0 30px',
    textAlign: 'center',
    borderBottom: `6px solid ${MAIN_THEME.color.red}`,
    fontFamily: MAIN_THEME.font.medium,
  },
  leftSideItem: {
    margin: '0 0 15px',
  },
  leftSideItemTitle: {
    fontSize: MAIN_THEME.fontSize.rg,
    margin: '0',
    fontFamily: MAIN_THEME.font.medium,
  },
  leftSideItemValue: {
    fontSize: MAIN_THEME.fontSize.rg,
    margin: '0',
    fontFamily: MAIN_THEME.font.regular,
  },
}));

const LeftSideStaticColumn: React.FC<ILeftSideStaticColumn> = ({
  title,
  fields,
}) => {
  const { classes, cx } = useStyles();

  return (
    <div>
      <p className={classes.leftSideTitle}>{title}</p>
      {fields.map((field) => (
        <p
          key={field.title}
          className={cx(classes.leftSideItem, classes.leftSideItemValue)}
        >
          <span className={classes.leftSideItemTitle}>{`${field.title} `}</span>
          {field.value}
        </p>
      ))}
    </div>
  );
};

export default LeftSideStaticColumn;
